import {
  FormLabelInput,
  TitleInputContainer,
  TitleDescription,
  FormInput,
} from "@/components/ui/form-elements";
import {
  AndOrContainer,
  ConditionContainer,
  PlusIconContainer,
  ConfitionTitle,
} from "./ConditionalBlockNodeEditor.styled";
import {
  Select,
  SelectContent,
  SelectItem,
  ClearableSelectTrigger,
  SelectValue,
} from "@/components/ui/select";
import EdsSearchableSelect from "../EdsSearchableSelect";
import NodeContext from "../../context/NodeContext";
import { useContext } from "react";
import { conditionOptions } from "../../utils/constants";
import { ReactComponent as DeleteIcon } from "../../assets/images/deleteIcon.svg?react";
import { ReactComponent as AddIcon } from "../../assets/images/addIcon.svg?react";

function ConditionalBlockNodeEditor() {
  const { selectedNodeInfo, updateNode, variableList, isEditable } =
    useContext(NodeContext);
  // useEffect(() => {
  //   if (!isSuperAdmin) {
  //     toast.error("You don't have permission to edit this node", {
  //       position: "top-center",
  //       autoClose: 3000,
  //       hideProgressBar: false,
  //       closeOnClick: true,
  //       draggable: true,
  //     });
  //   }
  // }, [isSuperAdmin, selectedNodeInfo?.id, isEditable]);
  if (!selectedNodeInfo) {
    return null;
  }
  return (
    <>
      <TitleInputContainer>
        <FormLabelInput
          placeholder="Label"
          value={selectedNodeInfo?.data?.titleText}
          onChange={(e) => {
            updateNode(selectedNodeInfo.id, {
              ...selectedNodeInfo?.data,
              titleText: e.target.value,
            });
          }}
          readOnly={!isEditable}
        />
        <TitleDescription>Conditional block lets you run flow based on some conditions</TitleDescription>
      </TitleInputContainer>
      {selectedNodeInfo?.data?.conditions?.map((item, index) => (
        <div key={`CodeBlockEditorElement-${index}`}>
          <ConfitionTitle>
            <p>
              {" "}
              Condition{" "}
              {selectedNodeInfo?.data?.conditions[index]?.conditionTitle}
            </p>
            {selectedNodeInfo?.data?.conditions?.length > 1 && (isEditable) && (
              <DeleteIcon
                onClick={() => {
                  const conditions = selectedNodeInfo?.data?.conditions;

                  conditions.splice(index, 1);

                  updateNode(selectedNodeInfo.id, {
                    ...selectedNodeInfo?.data,
                    conditions,
                  });
                }}
              />
            )}
          </ConfitionTitle>
          <ConditionContainer>
            <EdsSearchableSelect
              options={variableList.map((variable) => {
                if(variable?.type !== 'custom'){
                  return {
                      ...variable,
                      type : "system"
                  };
                }
                return variable;
              })}
              value={item.variableName ? item.variableName.replace(/^\{/, '') : ""}
              onChange={(value) => {
                const selectedVar = variableList.find((o) => String(o.value) === value);
                const conditions = selectedNodeInfo?.data?.conditions;
                conditions[index].variableName = `{${selectedVar?.value || value}`;
                conditions[index].id = selectedVar?.id;

                updateNode(selectedNodeInfo.id, {
                  ...selectedNodeInfo?.data,
                  conditions,
                });
              }}
              isDisabled={!isEditable}
              placeholder="Select variable name"
              showTypeLabel={true}
              key={`variable-${selectedNodeInfo?.id}-${index}`}
            />
            <Select
              value={item?.condition || ""}
              onValueChange={(value) => {
                const conditions = selectedNodeInfo?.data?.conditions;
                conditions[index].condition = value;

                updateNode(selectedNodeInfo.id, {
                  ...selectedNodeInfo?.data,
                  conditions,
                });
              }}
              disabled={!isEditable}
              key={`condition-${selectedNodeInfo?.id}-${index}`}
            >
              <ClearableSelectTrigger 
                className="w-full"
                showClear={!!item?.condition}
                onClear={() => {
                  const conditions = selectedNodeInfo?.data?.conditions;
                  conditions[index].condition = "";

                  updateNode(selectedNodeInfo.id, {
                    ...selectedNodeInfo?.data,
                    conditions,
                  });
                }}
              >
                <SelectValue placeholder="Select operator" />
              </ClearableSelectTrigger>
              <SelectContent>
                {conditionOptions.map((option) => (
                  <SelectItem key={option.value} value={option.value}>
                    {option.label}
                  </SelectItem>
                ))}
              </SelectContent>
            </Select>
            <FormInput
              placeholder="Enter value"
              value={item?.value}
              onChange={(e) => {
                const conditions = selectedNodeInfo?.data?.conditions;
                conditions[index].value = e.target.value;

                updateNode(selectedNodeInfo.id, {
                  ...selectedNodeInfo?.data,
                  conditions,
                });
              }}
              readOnly={!isEditable}
            />
          </ConditionContainer>
          {index === selectedNodeInfo?.data?.conditions?.length - 1 ? null : (
            <AndOrContainer>
              <span
                className={item.andOr === "and" ? "active" : ""}
                onClick={() => {
                  if (!isEditable) return;
                  const conditions = selectedNodeInfo?.data?.conditions;
                  conditions[index].andOr = "and";

                  updateNode(selectedNodeInfo.id, {
                    ...selectedNodeInfo?.data,
                    conditions,
                  });
                }}
              >
                And
              </span>
              <span
                className={item.andOr === "or" ? "active" : ""}
                onClick={() => {
                  if (!isEditable) return;
                  const conditions = selectedNodeInfo?.data?.conditions;
                  conditions[index].andOr = "or";

                  updateNode(selectedNodeInfo.id, {
                    ...selectedNodeInfo?.data,
                    conditions,
                  });
                }}
              >
                Or
              </span>
            </AndOrContainer>
          )}
          {index === selectedNodeInfo?.data?.conditions?.length - 1 && (isEditable) &&
            selectedNodeInfo?.data?.conditions?.length < 10 ? (
            <PlusIconContainer
              onClick={() => {
                const conditions = selectedNodeInfo?.data?.conditions;
                conditions.push({
                  variableName: "",
                  condition: "",
                  value: "",
                  andOr: "and",
                  conditionTitle:
                    parseInt(
                      selectedNodeInfo?.data?.conditions.at(-1).conditionTitle
                    ) + 1,
                });
                updateNode(selectedNodeInfo.id, {
                  ...selectedNodeInfo?.data,
                  conditions,
                });
              }}
            >
              <AddIcon />
            </PlusIconContainer>
          ) : null}
        </div>
      ))}
    </>
  );
}

export default ConditionalBlockNodeEditor;
